const pathToHide = ["landing", "unitypoint", "CHIhealth", "BooneHealth"];

export {
    pathToHide
}
